import { Injectable } from '@angular/core';

import { ShiftProvider } from '../shift-provider';
import { Store } from '@ngrx/store';
import { GlobalEndPoints, GlobalEnvProvider } from '../global-env-provider';
import { IAppState } from '../../state';
import { InitializeHeader, InitializeShift } from '../../state/header/header.actions';
import { THeaderResponse, TShiftDtoResponse } from '@monorepo/types';
import { CapacitorHttpService, TUserLoggedInInfo, UnifiedLoginService } from '@monorepo/services';
import { HeaderFacade } from '../../state/header/header.facade';
@Injectable({
  providedIn: 'root',
})
export class ResolverApp {
  constructor(
    private envProvider: GlobalEnvProvider,
    private shiftProvider: ShiftProvider,
    private store: Store<IAppState>,
    private unifiedLoginService: UnifiedLoginService,
    private capacitorHttpService: CapacitorHttpService,
    private headerFacade: HeaderFacade,
  ) {}

  resolve() {
    return Promise.all([this.getHeaderMetaData(), this.getShiftMetaData()]).finally(() => {
      this.headerFacade.headerLoaded();
    });
  }

  private getShiftMetaData() {
    const url = this.envProvider.getEnvVar(GlobalEndPoints.GET_SHIFTS);
    const postData = { subject_key: this.unifiedLoginService.getUserInfo().factoryId };

    return this.capacitorHttpService
      .postPromise<TShiftDtoResponse>(url, postData, {
        'Content-Type': 'application/json',
      })
      .then((shiftResponse) => {
        this.shiftProvider.setShiftData(shiftResponse);
        this.store.dispatch(new InitializeShift(shiftResponse));
        return shiftResponse;
      });
  }

  private getHeaderMetaData() {
    const url = this.envProvider.getEnvVar(GlobalEndPoints.GET_HEADER_METADATA);
    //Header Authorization is added because resolving seems to bypass the interceptor

    // this.store.dispatch(
    //   new InitializeHeader({
    //     headerResponse: headerResponse.data as THeaderResponse,
    //     subjectKey: this.unifiedLoginService.getUserInfo().factoryId,
    //   }),
    // );

    // return new Promise((resolve, reject) => {
    //   resolve(headerResponse);
    // });

    return this.capacitorHttpService
      .get<THeaderResponse>(url, null, {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${(this.unifiedLoginService.getUserInfo() as TUserLoggedInInfo).legacyJWT}`,
      })
      .then((response) => {
        if (!response.data || response.status !== 200) {
          if ([401, 403].includes(response.status)) {
            this.unifiedLoginService.redirectToLogin();
            throw new Error('Authentication failed');
          }
          throw new Error(`Header API failed with status ${response.status}`);
        }

        this.store.dispatch(
          new InitializeHeader({
            headerResponse: response.data,
            subjectKey: this.unifiedLoginService.getUserInfo().factoryId,
          }),
        );
        return response.data;
      });
  }
}
